import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogRef, MatDialogContent } from '@angular/material/dialog';
import { f3Animations } from '@f3/animations';
// import { GwcApiIndividualOrdersService } from '@core/services/gwc-api/individual-orders.service';
// import { CookieService } from 'ngx-cookie-service';
// import { OrderService } from '../../services/order.service';
import { faCheckCircle, faCreditCard,faShoppingCart, faFileInvoiceDollar,faClipboardCheck } from '@fortawesome/free-solid-svg-icons';
import { LoadingComponentService } from '@gwc/loading/loading-component.service';
import * as _ from 'lodash-es';
// import { LoadingComponentService } from '@core/components/loading/loading-component.service';
import { Observable, of, Subject } from 'rxjs';
import { CasualHireFormService } from '../../casual-hire-form.service';
import { Step } from '../../form-step.type';
import { LoadingModule } from '../../../../../../../../@gwc/loading/loading.module';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgClass, NgStyle } from '@angular/common';

@Component({
    selector: 'casual-hire-process-order-dialog',
    templateUrl: './process-order-dialog.component.html',
    encapsulation: ViewEncapsulation.None,
    // changeDetection: ChangeDetectionStrategy.OnPush,
    animations: f3Animations,
    standalone: true,
    imports: [MatDialogContent, NgClass, NgStyle, FaIconComponent, LoadingModule]
})
export class ProcessOrderDialogComponent implements OnInit, OnDestroy {

	// @Public Properties
	public processSteps: any = [
		{
			id: 'validateCreditCard',
			title: 'Validate Credit Card',
			icon: faCreditCard,
			rank: 1,
			status: false,
			loading: true
		},
		{
			id: 'createOrder',
			title: 'Create Order',
			icon: faShoppingCart,
			rank: 2,
			status: false,
			loading: false
		},
		{
			id: 'processPayment',
			title: 'Process Payment',
			icon: faFileInvoiceDollar,
			rank: 3,
			status: false,
			loading: false
		},
		{
			id: 'confirmOrder',
			title: 'Confirm Order',
			icon: faClipboardCheck,
			rank: 4,
			status: false,
			loading: false
		}
	]

	public currentStep = 'validateCreditCard';

	public faCheckCircle = faCheckCircle

	public steps$: Observable<Step[]> = of([])

	// @Private Properties
	private _unsubscribeAll: Subject<any> = new Subject


	/**'
	 * Constructor
	 */
	constructor(
		private _matDialogRef: MatDialogRef<ProcessOrderDialogComponent>,
		private _loadingService: LoadingComponentService,
		private _casualHireFormService: CasualHireFormService
	) {  }


	

	//--------------------------------------------------------------------------------
	// @Lifecycle Hooks
	//--------------------------------------------------------------------------------

	/**
	 * On Init
	 */
	ngOnInit(): void {

		this._casualHireFormService.processOrder()
		.subscribe(
			(result: any) => {

				switch(result) {
					case 'SUCCESS_STRIPE_TOKEN' :
						this._loadingService.stop('validateCreditCardLoader')
						this.currentStep = 'createOrder';
						this._loadingService.start('createOrderLoader')

						_.find(this.processSteps, function(step) { return step.id == 'validateCreditCard'; }).status = true;

						break;
					case 'SUCCESS_CREATE_ORDER' :
						this._loadingService.stop('createOrderLoader')
						this.currentStep = 'processPayment';
						this._loadingService.start('processPaymentLoader')

						_.find(this.processSteps, function(step) { return step.id == 'createOrder'; }).status = true;
						break;
					case 'SUCCESS_PROCESS_PAYMENT' :
						this._loadingService.stop('processPaymentLoader')
						this.currentStep = 'confirmOrder';
						this._loadingService.start('confirmOrderLoader')

						_.find(this.processSteps, function(step) { return step.id == 'processPayment'; }).status = true;
						break;
					case 'OK' :
						this._loadingService.stop('confirmOrderLoader')
						_.find(this.processSteps, function(step) { return step.id == 'confirmOrder'; }).status = true;
						this._matDialogRef.close();

						break;

				}

			}
		)


	}

	/**
	 * On Destroy
	 */
	ngOnDestroy(): void {
		this._unsubscribeAll.next(null);
		this._unsubscribeAll.complete()
	}


	//--------------------------------------------------------------------------------
	// @Public Methods
	//--------------------------------------------------------------------------------


}
